import { render, staticRenderFns } from "./ModuleSix.vue?vue&type=template&id=237a3e86&scoped=true"
import script from "./ModuleSix.vue?vue&type=script&lang=js"
export * from "./ModuleSix.vue?vue&type=script&lang=js"
import style0 from "./ModuleSix.vue?vue&type=style&index=0&id=237a3e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237a3e86",
  null
  
)

export default component.exports